
import AppFrequencyDocumentEdit from "@/components/frequency-documents/FrequencyDocumentEdit.vue";
import { FrequencyDocument } from "@/models/base";
import { FrequencyDocumentService } from "@/services/frequency-document-service";
import { ToolbarService } from "@/services/toolbar-service";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import Vue from "vue";
import { SaleService } from "../../services/sale-service";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { FrequencyDocumentEditState } from "@/utils/frequency-document-edit-state";
import { ConfirmResult } from "winfakt-vue-components";


export default Vue.extend({
	data() {
		let warningText = () => {
			return "test";
		};
		return {
			document: new FrequencyDocument(),
			pendingChangesNotifier: new PendingChangesNotifier(this, "documentString", {warningText}),
			ready: false,
			state: null as null | FrequencyDocumentEditState
		};
	},
	computed: {
		documentString():string {
			return JSON.stringify(this.document.getJSON());
		},
		title():string {
			if (this.document.ID == 0) {
				return this.$ct("create-subscription").toString();
			}
			return this.$ct("edit-subscription").toString();
		},
		pendingChangesWarningText(): string{
			if (!this.document.Sale) return "";
			return this.$ct("save-confirm",{type: this.saleName, id: this.document.Sale.ComputedFriendlyID}).toString();
		},
		saleName(): string {
			if (!this.document.Sale) return "";
			return this.document.Sale.Type.Name.getTranslation(this.document.Sale.getLng()).toLowerCase();
		},
	},
	watch: {
		title: {
			immediate: true,
			handler() {
				ToolbarService.title = this.title;
			}
		}
	},
	methods: {
		async close(){
			this.$router.push("/subscriptions");
		},
		async onSaved(doc:FrequencyDocument) {
			this.document = doc;
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
			this.$emit("created-new-doc", this.document);
			this.close();
		}
	},
	async created() {
		if (!checkHasModule(MODULE.ABONNEMENTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
		let id = parseInt(this.$route.params.id || "0");
		this.document.SaleType = await SaleService.getType(1);
		if (id) {
			this.document = await FrequencyDocumentService.getDocument(id);
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		}

		this.pendingChangesNotifier = new PendingChangesNotifier(this, "documentString", {warningText: ()=>this.pendingChangesWarningText});
		this.ready = true;
	},
	components: {
		AppFrequencyDocumentEdit
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
	async beforeRouteLeave(to, from, next) {
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			if(this.state && this.pendingChangesNotifier.changesPending && this.document.Sale){
				if (!this.document.Sale.ContactID) {
					this.$wf.notify(this.$ct("error-contact-empty").toString(), "danger", 3500, "exclamation-triangle");
					return false;
				}
				this.state.openSaveModal();
				return;
			}
		}
		next();
	}
});
